module.exports = __webpack_public_path__ + "img/lavente.a9864f3b.png";